module.exports = __webpack_public_path__ + "31caf9609fe097ab825eea5f445e4465.obj";